// src/plugins/openReplay.js
import Tracker from "@openreplay/tracker";

export const tracker = new Tracker({
  projectKey: "vgdm84GioRYhz6Y8J245",
  ingestPoint: "https://replays.carrotsolutions.co.kr/ingest",
  crossdomain: {
    parentDomain: "*",
    enabled: true,
  },
  network: {
    capturePayload: true,
  },
  captureIFrames: true,
  __DISABLE_SECURE_MODE: true,
});

export default tracker;
